import {
  queryAddEditDigitalSignature,
  queryAddNewDigitalSignature,
  queryDeleteItem,
  queryEditItemDigitalSignature,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'actionDigitalSignatureFieldMapping',
  state: {
    newDigitalSignature: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,signaturePosition,isShowDigitalSignatureStampEnabled, pageToPlaceDigitalStamp',
    notSelectSearch:
      'signaturePosition,isShowDigitalSignatureStampEnabled, pageToPlaceDigitalStamp',
    expand: {
      form: { select: 'name' },
      field: { select: 'displayText' },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryDigitalSignatures',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewDigitalSignature({ payload }, { put }) {
      yield put({
        type: 'addDigitalSignature',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewDigitalSignature',
          payload,
        });
      }
    },

    *editItemDigitalSignature({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemDigitalSignature, payload);
        yield put({
          type: 'editDigitalSignature',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewDigitalSignature({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewDigitalSignature, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveDigitalSignature',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditDigitalSignature({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditDigitalSignature, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveDigitalSignature',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveDigitalSignature',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemDigitalSignature({ view }, { put }) {
      yield put({
        type: 'showEditItemDigitalSignature',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryDigitalSignatures(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addDigitalSignature(state, { payload }) {
      return {
        ...state,
        newDigitalSignature: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewDigitalSignature(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editDigitalSignature(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveDigitalSignature(state, { payload }) {
      return {
        ...state,
        saveDigitalSignature: payload,
        newDigitalSignature: false,
        selectedItem: false,
      };
    },

    showEditItemDigitalSignature(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newDigitalSignature: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
